import Permission from "../class/Permission";

class PermissionFactory
{
  constructor(self) {
    this.permissions = []
    this.allowed_permission_names = {
      'permission' : new Permission(self),
    }
  }

  getPermission(permission_name)
  {
    if (!this.allowed_permission_names.hasOwnProperty(permission_name)) {
      return null;
    } else {
      if (this.permissions.hasOwnProperty(permission_name)) {
        return this.permissions[permission_name];
      } else {
        let object_permission = this.allowed_permission_names[permission_name];
        this.permissions[permission_name] = object_permission;
        return object_permission;
      }
    }
  }
}

export default PermissionFactory
